import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBathWoman1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bath-woman-1, women, female"><circle cx="12" cy="4" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M15.25 22.25V18.75H17.75L15.25 8.75H8.75L6.25 18.75H8.75V22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBathWoman1;
